// extracted by mini-css-extract-plugin
export default {"container":"OK-z","modal":"PK-z","dimensions":"QK-z","brandName":"RK-z","productName":"SK-z","labelValue":"TK-z","recipientEmail":"UK-z","recommendedFit":"VK-z","hiddenField":"WK-z"};